<template lang="pug">
  .woocommerce
    v-container(style="max-width:600px")
      v-layout.mt-3(v-if="!setupDone")
        v-row.fill-height.ma-0(align='center' justify='center')
          div.mx-auto
            v-img.mx-auto(:src="require('@/assets/images/woo-logo.png')" style="width:140px" contain)

      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

      v-card.mt-6(v-else flat)
        v-card-title
          v-layout
            div(v-if="setupDone")
            div(v-else)
              p.h6.ma-0 {{ $t('set_api_keys') }}
              p.p2.mt-2.ma-0.primary500--text {{ $t('refer_how_to') }}s&nbsp;
                a.p2.accent--text(href="https://docs.woocommerce.com/document/woocommerce-rest-api/" target="_blank") {{ $t('here') }}
                | .
              p.ma-0.p2.primary500--text(v-html="$t('make_sure_to_choose')")
        
        v-window.pa-4
          v-window-item(v-if='!setupDone')
            v-form(ref="form")
              .api-key
                p.label.basic600--text.text-uppercase {{ $t('field_website_url.label') }}
                v-text-field.p1(solo flat background-color="basic200"    height="40" v-model='woocommerce.url' label="Website URL" :placeholder="$t('field_website_url.placeholder')" outlined dense persistent-hint :rules="rules.not_empty")
                p.label.basic600--text.text-uppercase {{ $t('field_consumer_key.label') }}
                v-text-field.p1(solo flat background-color="basic200"    height="40" v-model='woocommerce.consumer_key' label="Copy and paste Consumer Key here" :placeholder="$t('field_consumer_key.placeholder')" outlined dense persistent-hint :rules="rules.not_empty")
                p.label.basic600--text.text-uppercase {{ $t('field_secret.label') }}
                v-text-field.p1(solo flat background-color="basic200"    height="40" v-model='woocommerce.consumer_secret' label="Consumer Secret" @focus="woocommerce.consumer_secret = ''" :placeholder="$t('field_secret.placeholder')" outlined dense persistent-hint :rules="rules.not_empty")
          v-window-item(v-else)
            v-row.fill-height.ma-0(align='center' justify='center')
              div.mx-auto
                v-img.mx-auto(:src="require('@/assets/images/woo-logo.png')" style="width:120px" contain)
                div.mt-2.caption.text-center(v-html="$t('congratulation_your_woocommerce')")
       
        v-card-actions
          v-spacer
          v-btn.button-AA-medium.white--text(v-if="setupDone" color='info500' height=32 depressed @click="finish")
            | {{ $t('finish') }}
          v-btn.button-AA-medium.white--text(v-else color='info500' height=32 depressed @click="save()" :loading="loading")
            | {{ $t('connect') }}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'SetupWooCommerce',
  props: [ 'company', 'ecommerce'],
  data: () => ({
    loading: false,
    setupDone: false,
    isFetching: true,
    woocommerce : {
      url: '',
      consumer_key: '',
      consumer_secret: ''
    },
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'Item is required', (v) => v != 0|| 'Item is required']
    }
  }),
  computed: {
  },
  watch: {
    ecommerce: {
      deep: true,
      immediate: true,
      handler (val) {
        if(val.id) {
          this.fetchWoo()
        } else {
          this.isFetching = false
        }
      }
    }
  },
  mounted () {
    // this.fetchWoo()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchWoo () {
      this.woocommerce = {...this.ecommerce}
      this.isFetching = false
    },
    save () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      if (this.woocommerce.url.substr(0, 4) === 'http') {
        if (this.woocommerce.id) {
          let data = {
            url: this.woocommerce.url,
            consumer_key: this.woocommerce.consumer_key,
          }
          if (this.ecommerce.consumer_secret !== this.woocommerce.consumer_secret) {
            data.consumer_secret =  this.woocommerce.consumer_secret
          }
          this.axios.patch(`/ecommerce/woocommerce/${this.woocommerce.id}/`, data)
          .then(() => {
            this.setupDone = true
          })
          .catch(() => {
            this.showMessage(['error', `Unable to connect with ${this.woocommerce.url}. Please make sure consumer key and secret are correct.`])
          })
          .finally(() => {
            this.loading = false
          })
        } else {
          let data = {
            company: this.company.id,
            url: this.woocommerce.url,
            consumer_key: this.woocommerce.consumer_key,
            consumer_secret: this.woocommerce.consumer_secret,
          }
          this.axios.post(`/ecommerce/woocommerce/`, data)
          .then(() => {
            this.setupDone = true
          })
          .catch(() => {
            this.showMessage(['error', `Unable to connect with ${this.woocommerce.url}. Please make sure consumer key and secret are correct.`])
          })
          .finally(() => {
            this.loading = false
          })
        }
      } else {
        this.showMessage(['error', `Please make sure your url start with 'http...'`])
        this.loading = false
      }
    },
    finish () {
      document.location.href = '/admin/settings/woocommerce'
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "set_api_keys": "Set API keys",
    "refer_how_to": "Refer how to generate API key",
    "here": "here",
    "make_sure_to_choose": "Make sure to choose <b>Read/Write</b> as level of access.",
    "field_website_url": {
      "label": "Website URL",
      "placeholder": "eg: https://www.arbatravel.com"
    },
    "field_consumer_key": {
      "label": "Consumer Key",
      "placeholder": "eg: ck_f7424******************************31db7"
    },
    "field_secret": {
      "label": "Consumer Secret",
      "placeholder": "eg: cs_3818e******************************3bf45"
    },
    "congratulation_your_woocommerce": "Congratulation! <br> Your WooCommerce site is now connected to Yezza.",
    "finish": "Finish",
    "connect": "Connect"
  },
  "id": {
    "set_api_keys": "Setel kunci API",
    "refer_how_to": "Lihat cara membuat kunci API",
    "here": "di sini",
    "make_sure_to_choose": "Pastikan untuk memilih <b>Baca/Tulis</b> sebagai tingkat akses.",
    "field_website_url": {
      "label": "URL Situs Web",
      "placeholder": "misalnya: https://www.arbatravel.com"
    },
    "field_consumer_key": {
      "label": "Kunci Konsumen",
      "placeholder": "mis.: ck_f7424******************************31db7"
    },
    "field_secret": {
      "label": "Rahasia Konsumen",
      "placeholder": "misalnya: cs_3818e******************************3bf45"
    },
    "congratulation_your_woocommerce": "Selamat! <br> Situs WooCommerce kamu sekarang terhubung ke Yezza.",
    "finish": "Selesai",
    "connect": "menghubungkan"
  }
}
</i18n>